import { render, staticRenderFns } from "./store-info.vue?vue&type=template&id=f48e3d6c&scoped=true"
import script from "./store-info.vue?vue&type=script&lang=js"
export * from "./store-info.vue?vue&type=script&lang=js"
import style0 from "./store-info.vue?vue&type=style&index=0&id=f48e3d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e3d6c",
  null
  
)

export default component.exports